export default class SimulatedAccountLendingInterestSettings {
    rateType: string;
    rateValue: number;
    rateSourceId: string;
}